function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    bxtransform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
    xmlnsbx: "https://boxy-svg.com",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.414 8.027 L 19.434 8.027 L 19.434 11.002 L 24.414 11.002 C 25.896 11.002 27.043 11.762 27.043 12.418 L 27.043 25.609 C 27.043 26.264 25.896 27.026 24.414 27.026 L 5.585 27.026 C 4.105 27.026 2.956 26.262 2.956 25.609 L 2.956 12.419 C 2.956 11.761 4.105 11.001 5.585 11.001 L 10.565 11.001 L 10.565 8.026 L 5.585 8.026 C 2.453 8.026 0 9.955 0 12.419 L 0 25.609 C 0 28.073 2.453 30 5.585 30 L 24.415 30 C 27.546 30 30 28.071 30 25.609 L 30 12.422 C 30 9.958 27.547 8.029 24.413 8.029",
    style: {
      strokeWidth: 1,
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.472 14.245 C 19.08 14.245 18.704 14.402 18.427 14.68 L 16.576 16.542 L 16.576 1.411 C 16.516 0.267 15.246 -0.382 14.292 0.243 C 13.896 0.502 13.647 0.936 13.622 1.411 L 13.622 16.643 L 11.672 14.68 C 11.096 14.096 10.157 14.096 9.58 14.68 C 9.003 15.261 9.003 16.203 9.58 16.783 L 13.993 21.224 C 14.269 21.504 14.646 21.661 15.038 21.659 C 15.438 21.664 15.822 21.507 16.105 21.224 L 20.517 16.783 C 21.323 15.975 20.958 14.593 19.86 14.294 C 19.734 14.26 19.603 14.243 19.472 14.243",
    style: {
      strokeWidth: 1,
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.7b8475dce6d5662bc3d434740c88b988.svg";
export { ForwardRef as ReactComponent };